import { IIvr } from '../shared/types/ivr';
import { apiService } from './index';

export const asyncGetIvr = async (page?: number, pageSize?: number) => {
    return await apiService.get('/api/ivr', {
        limit: pageSize || '',
        page: page || '',
    });
};

export const asyncGetLatestIvr = async (): Promise<IIvr | null> => {
    try {
        const response = await apiService.get<{ items: IIvr }>(
            '/api/ivr/latest'
        );
        return response?.items || null;
    } catch (error) {
        return null;
    }
};

export const asyncPostIvr = async (formMessage: IIvr) => {
    return await apiService.post('/api/ivr', formMessage);
};
